<template>
  <div>
    <div id="gmap" class="gmap"></div>
    <!-- <span>{{this.newLat}} </span>
    <span>{{this.newLng}}</span> -->
  </div>
</template>

<script>
export default {
  name: 'Gmap',

  props: {
  /*
    lat: {
      type: String // saako jotenkin suoraan nnumerona?
    },
    lng: {
      type: String // saako jotenkin suoraan nnumerona?
    }
  */
    coords: {
      type: Array
    }
  },

  computed: {
    newLat () {
      // var lat = parseFloat(this.lat, 10)
      var lat = parseFloat(this.coords[0], 10)
      return lat
    },
    newLng () { // tämä on tautologiaa!! tee lopuksi paremmin
      // var lng = parseFloat(this.lng, 10)
      var lng = parseFloat(this.coords[1], 10)
      return lng
    }
  },

  methods: {
    handleMap () {
      /* global google */
      const map = new google.maps.Map(document.getElementById('gmap'), {
        center: { lat: this.newLat, lng: this.newLng },
        zoom: 17,
        maxZoom: 19,
        minZoom: 3,
        streetViewControl: true
      })
      return new google.maps.Marker({ position: { lat: this.newLat, lng: this.newLng }, map: map })
    }
  },

  mounted () {
    this.handleMap()
  },

  watch: {
    coords: {
      deep: true,
      handler () {
        this.handleMap()
      }
    }

  }
}
</script>

<style lang="scss">
.gmap {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  //max-width: 600px;
  height: 100%;
  // min-height: 40vh;
  margin: 0 auto;
  border: 1px solid rgb(180, 180, 180);
  // padding: 5px;
  // background-color: blue;
}
</style>
